import { render, staticRenderFns } from "./articulo.vue?vue&type=template&id=78b4f5ea&scoped=true&"
import script from "./articulo.vue?vue&type=script&lang=ts&"
export * from "./articulo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78b4f5ea",
  null
  
)

export default component.exports